module.exports = __webpack_public_path__ + "media/images/swifticons/textmessaging-9c1a8dce48a7fcc4a95d805b56c10424.svg";